import React, { useEffect, useState } from "react";
import Title from "../../Components/Admin/Title";
import { IoSettingsOutline } from "react-icons/io5";
import Swal from "sweetalert2";
import {
    SETTING_FETCH_URL,
    SETTING_UPDATE_URL,
} from "../../utils/Constant";

function Settings() {
    const [formData, setFormData] = useState({
        logo: null,
        email: "",
        phone: "",
    });

    const [preview, setPreview] = useState("");

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const res = await fetch(SETTING_FETCH_URL, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
                },
            });

            const result = await res.json();
            console.log("settings result:", result);

            if (result.success && result.setting) {
                setFormData({
                    logo: null,
                    email: result.setting.email || "",
                    phone: result.setting.phone || "",
                });

                setPreview(result.setting.logo_url || "");
            } else {
                setPreview("");
            }
        } catch (error) {
            console.error("Fetch settings error:", error);
            Swal.fire("Error", "Failed to fetch settings", "error");
        }
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (files && files[0]) {
            const file = files[0];

            setFormData((prev) => ({
                ...prev,
                [name]: file,
            }));

            setPreview(URL.createObjectURL(file));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();

        if (formData.logo) {
            data.append("logo", formData.logo);
        }

        data.append("email", formData.email);
        data.append("phone", formData.phone);

        try {
            const res = await fetch(SETTING_UPDATE_URL, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
                },
                body: data,
            });

            const result = await res.json();
            console.log("save result:", result);

            if (result.success) {
                Swal.fire("Success", result.message, "success");
                fetchSettings();
            } else {
                Swal.fire("Error", result.message || "Failed to save settings", "error");
            }
        } catch (error) {
            console.error("Save settings error:", error);
            Swal.fire("Error", "Something went wrong", "error");
        }
    };

    return (
        <>
            <Title icon={IoSettingsOutline} title="Settings" />

            <div className="bg-white rounded shadow-lg mt-5 p-6">
                <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                        <label className="label">Logo</label>
                        <input
                            type="file"
                            name="logo"
                            className="file-input file-input-bordered w-full"
                            onChange={handleChange}
                            accept=".jpg,.jpeg,.png,.webp"
                        />
                    </div>

                    {preview ? (
                        <img
                            src={preview}
                            alt="Logo"
                            className="max-h-24 w-auto border rounded object-contain"
                            onLoad={() => console.log("image loaded:", preview)}
                            onError={() => console.log("image failed:", preview)}
                        />
                    ) : (
                        <p>No logo available</p>
                    )}

                    <div>
                        <label className="label">Email</label>
                        <input
                            type="email"
                            name="email"
                            className="input input-bordered w-full"
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label className="label">Phone</label>
                        <input
                            type="text"
                            name="phone"
                            className="input input-bordered w-full"
                            value={formData.phone}
                            onChange={handleChange}
                        />
                    </div>

                    <button className="btn btn-primary text-white">
                        Save Settings
                    </button>
                </form>
            </div>
        </>
    );
}

export default Settings;